import {getTestProps} from '@benchling/js-test-utils';
import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';
import {Node} from 'reactflow';

import {ProcessFlowchartEditorConfigurator} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/ProcessFlowchartEditorConfigurator';

import {ProcessTaskSchemaWithoutFlowchartConfigGraphQL} from '../../../../../../graphql-fragments/processes/schemas/__generated/ProcessTaskSchemaWithoutFlowchartConfigGraphQL';
import {NODE_SECTION_TO_HEADER_TITLE, UserFacingNodeTypes} from '../processFlowchartConfigEditorConstants';
import {ProcessFlowchartNodeSection} from '../processFlowchartConfigEditorConstants';
import {NODE_SECTION_TO_RENDERER} from '../processFlowchartConfigEditorRegistry';
import {FlowchartOptions} from '../processFlowchartConfigEditorUtils';
import {ConfigurableTaskDefinitionGQL} from '../useAllSchemasById';

export interface NodeSidepanelSectionProps {
  section: ProcessFlowchartNodeSection;
  nodeTypes: Array<UserFacingNodeTypes>;
  addNodeToCanvas: (newNode: Node<unknown>) => void;
  taskDefinitionsForSidepanel: Array<ConfigurableTaskDefinitionGQL>;
  options: FlowchartOptions;
  searchQuery: string | null;
  rootTaskSchema: ProcessTaskSchemaWithoutFlowchartConfigGraphQL;
  flowchartEditorConfigurator: ProcessFlowchartEditorConfigurator;
  reactFlowWrapper: React.RefObject<HTMLDivElement>;
}

/**
 * An expandable section of the sidepanel
 */
export function NodeSidepanelSection(props: NodeSidepanelSectionProps): JSX.Element {
  return (
    <div className={css(styles.section)}>
      <div
        className={css(styles.header)}
        {...getTestProps({component: 'NodeSidepanelSection', element: 'header', key: props.section})}
      >
        <span className={css(styles.title)}>{NODE_SECTION_TO_HEADER_TITLE[props.section]}</span>
      </div>
      {NODE_SECTION_TO_RENDERER[props.section](props)}
    </div>
  );
}

const styles = StyleSheet.create({
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '6px',
    alignSelf: 'stretch',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    alignSelf: 'stretch',
    paddingTop: '16px',
  },
  title: {
    color: Color.GRAY_700,
    userSelect: 'none',
  },
  chevron: {
    color: Color.GRAY_500,
    width: '10px',
    height: '10px',
  },
});
